import type { EmptyResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';
import type { CommonResponse } from '@/utils/request';

export interface IRelation {
  userId: string;
  friendId: string;
  avatar: string;
  route: string;
  remark: string;
  relationRemark: string;
}

export interface IReportReason {
  code: string;
  desc: string;
}

export const updateRemark = (data?: {
  friendId: string;
  remark: string;
  relationRemark: string;
}) => {
  return Request<EmptyResponse>({
    url: '/rest/os/friend/update/remark',
    method: 'post',
    data
  });
};

export const getReportReason = () => {
  return Request<CommonResponse<IReportReason[]>>({
    url: '/rest/os/report/types',
    method: 'get'
  });
};

export const createReport = (data: {
  reportedUserId: string;
  sessionId?: string;
  reportType?: string;
  reportReason?: string;
  evidenceUrls?: string[];
}) => {
  return Request<CommonResponse<IReportReason[]>>({
    url: '/rest/os/report/create',
    method: 'post',
    data
  });
};
